module.exports = __webpack_public_path__ + "static/media/liebherr300.763d762f.pdf";